module.exports = __webpack_public_path__ + "images/emoji/watch.872d3fdcc47516702407.png";